import { useEffect, useState } from 'react';
import { ApiError } from '../../../../../shared/shared.api';
import { getPartType, type PartTypeView } from '../part-types.api';

export type PartTypeDetailState =
  { status: 'loading' } | { status: 'loaded'; partType: PartTypeView } | { status: 'not_found' } | { status: 'forbidden' } | { status: 'error' };

function toErrorState(err: unknown): PartTypeDetailState {
  if (err instanceof ApiError && err.status === 404) return { status: 'not_found' };
  return { status: err instanceof ApiError && err.status === 403 ? 'forbidden' : 'error' };
}

export function usePartTypeDetail(id: string): PartTypeDetailState {
  const [state, setState] = useState<PartTypeDetailState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    getPartType(id)
      .then((partType) => !cancelled && setState({ status: 'loaded', partType }))
      .catch((err) => !cancelled && setState(toErrorState(err)));
    return () => {
      cancelled = true;
    };
  }, [id]);

  return state;
}
